/**
 * Created by rathompson on 8/22/23
 * File: DotsButton.tsx
 * Project: cloud-mgmt-modules ©
 * ©
 */


import { forwardRef, ForwardRefExoticComponent } from 'react'
import { MoreIcon } from '@panwds/icons'

const DotsButton: ForwardRefExoticComponent<any> = forwardRef(({ ...props }, ref) => {
  return (
    <button
      ref={ref}
      style={{ height: 24, width: 24 }}
      className='context-btn cm-rounded-full cm-flex cm-items-center cm-justify-center'
      aria-label='context-icon'
      {...props}
    >
      <MoreIcon />
    </button>
  )
})

DotsButton.displayName = DotsButton.name

export default DotsButton
